import { styled } from 'theme'

export const StyledInvoiceTable = styled.div`
  background-color: white;
  .ant-table table {
    border-collapse: collapse;
  }
`
